@let cabinIsExpanded = cabinIsExpanded$ | async;
@let cabins = cabins$ | async;
@let selectedFareFamiliesPerCabin = selectedFareFamilyPerCabin$ | async;
@let minPricesPerCabin = minPricePerCabin$ | async;
<!--Expander cabin class + price -->
<ng-template #priceWithOriginal let-cabin="cabin" let-index="index">
  @let selectedFareFamilyPerCabin = selectedFareFamiliesPerCabin?.[cabin];
  @let minPricePerCabin = minPricesPerCabin?.[cabin];
  @let quota = minPricePerCabin?.quota;

  @if (cabinIsExpanded !== cabin) {
    <!-- x seats left -->
    @if (quota && quota < SEATS_LEFT_LIMIT && selectedFareFamilyPerCabin === null && !isMixedCabin) {
      <span class="heather-800-text font-body-1 ps-xsmall-r medium-type" data-testid="x-seats-left-text">
        {{ 'leftSeatsAvailable' | finPluralLocalization: quota }}
      </span>
    }
    <!-- Price from -->
    @if (!isAwardFlow && selectedFareFamilyPerCabin === null && !(quota < SEATS_LEFT_LIMIT)) {
      <span class="price-from-text font-body-2 nordic-blue-400-text ms-xxsmall-r" data-testid="price-from-text">
        {{ 'pricesStartingFrom' | finLocalization }}
      </span>
    }

    <!-- Price or Award point + price-->
    <span
      class="price-text font-body-1 bold-type nordic-blue-900-text nowrap"
      [attr.data-testid]="'cabin-selection-price-text-' + index"
    >
      @if (isAwardFlow) {
        {{ 'award.points' | finLocalization: { pointsAmount: minPricePerCabin?.points || 0 | finPoints } }}
        +
      }

      @if (cabinIsExpanded !== cabin) {
        @if (selectedFareFamilyPerCabin) {
          {{
            {
              amount: isShowTotalPrice ? selectedFareFamilyPerCabin.totalPrice : selectedFareFamilyPerCabin.price,
              currencyCode: currencyCode,
            } | finPrice
          }}
        } @else {
          @let price = isShowTotalPrice ? minPricePerCabin?.totalPrice : minPricePerCabin?.price;
          @let originalPrice =
            isShowTotalPrice ? minPricePerCabin?.originalTotalPrice : minPricePerCabin?.originalPrice;
          @let hasDiscountCode = originalPrice && minPricePerCabin?.discountReasonCode;
          <span [class.heather-700-text]="hasDiscountCode">
            {{ price | finPrice }}
          </span>
          @if (hasDiscountCode) {
            <span class="strike-through regular-type ms-xxsmall-l">{{ originalPrice | finPrice }}</span>
          }
        }
      }
    </span>
  }
</ng-template>

<!-- Cabin name template -->
<ng-template #cabinName let-cabin="cabin">
  @let minPricePerCabin = minPricesPerCabin?.[cabin];
  @if (!isAwardFlow || (isAwardFlow && cabinIsExpanded === null)) {
    <span [class.medium-type]="cabinIsExpanded === cabin" data-testid="cabin-name">{{
      'travelClass.' + (cabin | lowercase) | finLocalization
    }}</span>
  }
  @if (minPricePerCabin) {
    <fcom-icon
      *ngIf="
        (((isShowTotalPrice ? minPricePerCabin.originalTotalPrice : minPricePerCabin.originalPrice) &&
          minPricePerCabin.discountReasonCode) ||
          minPricePerCabin.isSpecialOffer) &&
        cabinIsExpanded !== cabin
      "
      class="ms-xsmall-l icon-medium heather-700-text"
      [name]="SvgLibraryIcon.DISCOUNT_BLOCK"
      [dataTestId]="'farefamily-special-offer-badge-' + cabin"
    />
  }

  @if (cabinIsExpanded === cabin) {
    <ng-container
      >{{ !isAwardFlow ? ':' : '' }} {{ 'ticketSelection.header.selectTicketTypeBelow' | finLocalization }}
    </ng-container>
  }
</ng-template>

<!-- Select fare family button -->
<ng-template #selectedFareFamily let-selectedFareFamily="selectedFareFamily">
  <span class="medium-type">{{ selectedFareFamily.benefits.brandName }}</span>
  <fcom-icon class="circle ms-xsmall-l" [name]="SvgLibraryIcon.CHECKMARK_BLOCK" />
</ng-template>

<!-- Cabin class button + fare family list -->
<ul class="no-list-style">
  @for (cabin of cabins; track trackByCabin(index, cabin); let index = $index; let first = $first; let last = $last) {
    @let selectedFareFamilyPerCabin = selectedFareFamiliesPerCabin?.[cabin];
    <li [attr.data-testid]="'fare-family-list-' + cabin">
      @if (!isAwardFlow || (isAwardFlow && cabinIsExpanded === cabin) || cabinIsExpanded === null) {
        <button
          [attr.data-testid]="'fare-family-list-button-' + cabin"
          (click)="toggleCabin(cabin)"
          class="fare-family-cabin flex fill ps-small-y pr-small-x border-top flex--center"
          [ngClass]="{
            border: isShowTotalPrice,
            'rounded-top-large': first && !last && roundedTop,
            'rounded-bottom-large': ((!first && last) || (!roundedTop && first && last)) && isShowTotalPrice,
            'rounded-large': first && last && roundedTop,
            'expander-open': cabinIsExpanded === cabin,
            'is-selected': cabinIsExpanded !== cabin && selectedFareFamilyPerCabin,
            first: first,
          }"
          [attr.aria-controls]="cabin + '-' + uuid"
          [attr.aria-expanded]="cabinIsExpanded?.[cabin]"
          [attr.aria-label]="
            cabinIsExpanded !== cabin && selectedFareFamilyPerCabin
              ? ('ticketSelection.aria.fareFamily.ariaCabinButtonSelected'
                | finLocalization
                  : {
                      fareFamily: selectedFareFamilyPerCabin?.benefits?.brandName,
                      price:
                        {
                          amount: selectedFareFamilyPerCabin.totalPrice,
                          currencyCode: currencyCode,
                        } | finPrice,
                    })
              : ('ticketSelection.aria.fareFamily.ariaCabinButtonUnselected'
                | finLocalization
                  : {
                      cabin: 'cabin.' + cabin.toLowerCase() | finLocalization,
                      priceFrom: minPricesPerCabin?.[cabin].totalPrice | finPrice,
                    })
          "
          [id]="cabin + '-' + uuid + '-button'"
          [style.background-color]="
            cabinIsExpanded !== cabin && selectedFareFamilyPerCabin
              ? selectedFareFamilyPerCabin?.benefits?.brandColor
              : null
          "
          [disabled]="minPricesPerCabin?.[cabin]?.disabled"
        >
          <div class="cabin-class-text flex flex-1 align-left font-body-1 nordic-blue-900-text">
            <div class="flex-1">
              @let isSelectedFareFamily = !!(cabinIsExpanded !== cabin && selectedFareFamilyPerCabin);
              @if (isSelectedFareFamily) {
                <ng-container
                  [ngTemplateOutlet]="selectedFareFamily"
                  [ngTemplateOutletContext]="{ selectedFareFamily: selectedFareFamilyPerCabin }"
                />
              } @else {
                <ng-container [ngTemplateOutlet]="cabinName" [ngTemplateOutletContext]="{ cabin: cabin }" />
              }
            </div>
            <div class="flex-1 dn-laptop-up">
              <ng-container
                [ngTemplateOutlet]="priceWithOriginal"
                [ngTemplateOutletContext]="{ cabin: cabin, index: index }"
              />
            </div>
          </div>
          <div class="flex-1 align-right dn-laptop-down">
            <ng-container
              [ngTemplateOutlet]="priceWithOriginal"
              [ngTemplateOutletContext]="{ cabin: cabin, index: index }"
            />
          </div>
          <div class="flex-1 flex--nogrow">
            <fcom-icon
              class="chevron-icon rotate ms-xlarge-l"
              [class.rotate-active]="cabinIsExpanded === cabin"
              [name]="SvgLibraryIcon.CHEVRON_DOWN"
            />
          </div>
        </button>
      }

      <fcom-expand
        [open]="cabinIsExpanded === cabin"
        [ariaId]="cabin + '-' + uuid"
        [ariaLabelledBy]="cabin + '-' + uuid + '-button'"
        [id]="cabin + '-' + uuid"
        (expanded)="cabinExpanded()"
      >
        @if (cabinIsExpanded === cabin) {
          <div
            class="pr-xsmall grey-50-bg"
            [ngClass]="{
              'border-bottom rounded-bottom': last,
              'border-right border-left': isShowTotalPrice,
            }"
          >
            <fcom-carousel
              [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
              [nextButtonAriaLabel]="'carousel.next' | finLocalization"
              [contentChanged$]="cabinIsExpanded | finToObservable"
              [initialElementToFocus]="preSelectedFareFamilyId"
              (finAfterViewInit)="afterCarouselViewInit()"
            >
              <fieldset class="flex fare-family-wrapper">
                <fin-fare-family-list-option
                  [id]="fareFamily.id"
                  *ngFor="
                    let fareFamily of fareFamiliesByCabin$ | finMap: cabin | async;
                    let last = last;
                    let index = index;
                    let count = count;
                    trackBy: trackByFn
                  "
                  class="flex flex-1"
                  [class.ms-small-r]="!last"
                  [fareFamily$]="fareFamily | finToObservable"
                  [currencyCode]="currencyCode"
                  [showKoreaNotification]="showKoreaNotification"
                  [aria]="{
                    index,
                    count,
                  }"
                  (selectFareFamily)="selectFareFamily.emit({ fareFamily, checked: $event, index })"
                  [isShowTotalPrice]="isShowTotalPrice"
                  [attr.data-testid]="'fare-family-list-option-' + (fareFamily?.benefits?.brandName | finKebab)"
                />
                @if (!isAwardFlow && shouldShowUpsellCard$ | async) {
                  @let upsellFareFamily = upsellCardFareFamily$ | async;

                  <fin-upsell-option
                    class="flex flex-1 ms-small-l"
                    [fareFamily]="upsellFareFamily"
                    [currencyCode$]="currencyCode | finToObservable"
                    [isShortHaul$]="isShortHaul$"
                    [isLongHaulLegAndAy$]="isLongHaulLegAndAy$"
                    (selectNextCabinClass)="openCabinAndSelect(upsellFareFamily)"
                    (openCabinClassModal)="openCabinClassModal.emit($event)"
                    [attr.data-testid]="'cabin-class-upsell-option'"
                  />
                }
              </fieldset>
            </fcom-carousel>
            <fcom-notification
              [attr.data-testid]="'ticket-type-details-notification-' + cabin"
              class="ms-small-t"
              [linkText]="'ticketSelection.baggageAndTicketTypeDetails' | finLocalization"
              [buttonStyle]="NotificationButtonStyle.LINK"
              [horizontal]="true"
              (linkClick)="openBenefitModal()"
            />
          </div>
        }
      </fcom-expand>
    </li>
  }
</ul>

<fcom-modal [(open)]="isTicketTypeModalOpen" [title]="'fareFamilyDetails.title' | finLocalization">
  <fin-fare-family-details-v2
    [dimensionsAndDetails$]="ticketTypeInfo$"
    [showKoreaNotification]="showKoreaNotification"
  />
</fcom-modal>
